import React from "react";
import { PanelView } from "screens/panels/components/PanelView";
import { PanelStep } from "screens/panels/components/PanelStep";
import { Wizard } from "react-use-wizard";
import { Text } from "@chakra-ui/react";
import { useConversation } from "hooks";
import type { JsonButton } from "types/charliui";
import { JsonView } from "screens/content/contentCanvas/body/JsonView";

type Props = {
  conversationId: string;
  buttonId?: string;
  title?: string;
  isOpen: boolean;
  onClose: () => void;
};

export const MessagesViewJsonPanel = ({ conversationId, buttonId, title, isOpen, onClose }: Props) => {
  const conversation = useConversation(conversationId);

  const maybeJsonButtonIfButtonId = conversation.messages
    .flatMap((message) => message.data ?? [])
    .find((uiElement): uiElement is JsonButton => uiElement.type === "json_button" && uiElement.body.buttonId === buttonId);

  const maybeJsonButton =
    maybeJsonButtonIfButtonId ??
    conversation.messages
      .find((message) => message.id === buttonId)
      ?.data?.find((uiElement): uiElement is JsonButton => uiElement.type === "json_button");

  return (
    <PanelView isOpen={isOpen} onClose={onClose} panelTitle={title}>
      <Wizard>
        <PanelStep>{maybeJsonButton ? <JsonView json={maybeJsonButton.body.json} /> : <Text>JSON content not found</Text>}</PanelStep>
      </Wizard>
    </PanelView>
  );
};
